/* AFC-style inline size picker behavior */
(function () {
  'use strict';

  const SELECTORS = {
    picker: '[data-afc-picker]',
    trigger: '[data-afc-trigger]',
    panel: '[data-afc-panel]',
    option: '[data-afc-variant-id]'
  };

  const ANCESTOR_CLASS = 'afc-open-ancestor';

  /* Cards (and the grid items around them) clip their overflow and stack in DOM
     order, so an absolutely-positioned panel gets cut off and painted under the
     products below it. Walk up from the quick-add wrapper to its grid item and
     flag each ancestor so CSS can un-clip and raise them for as long as the
     panel is open. */
  function clearAncestors() {
    document.querySelectorAll('.' + ANCESTOR_CLASS).forEach((el) => {
      el.classList.remove(ANCESTOR_CLASS);
    });
  }

  function raiseAncestors(picker) {
    const wrap = picker.closest('.afc-quick-add');
    let el = wrap ? wrap.parentElement : picker.parentElement;
    let depth = 0;
    while (el && el !== document.body && depth < 12) {
      el.classList.add(ANCESTOR_CLASS);
      if (el.classList.contains('grid__item') || el.tagName === 'LI') break;
      el = el.parentElement;
      depth += 1;
    }
  }

  /* Flip the panel above the bar when there isn't room below it. */
  function positionPanel(picker, panel) {
    panel.classList.remove('afc-picker__panel--up');
    const rect = panel.getBoundingClientRect();
    const barRect = picker.getBoundingClientRect();
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom > viewportH && barRect.top > rect.height) {
      panel.classList.add('afc-picker__panel--up');
    }
  }

  function closeAllPickers(except) {
    clearAncestors();
    document.querySelectorAll(SELECTORS.picker).forEach((p) => {
      if (p === except) return;
      const trigger = p.querySelector(SELECTORS.trigger);
      const panel = p.querySelector(SELECTORS.panel);
      if (panel) {
        panel.hidden = true;
        panel.classList.remove('afc-picker__panel--up');
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      const wrap = p.closest('.afc-quick-add');
      if (wrap) wrap.classList.remove('is-open');
    });
  }

  function openPicker(picker) {
    closeAllPickers(picker);
    const trigger = picker.querySelector(SELECTORS.trigger);
    const panel = picker.querySelector(SELECTORS.panel);
    if (!panel || !trigger) return;
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    const wrap = picker.closest('.afc-quick-add');
    if (wrap) wrap.classList.add('is-open');
    raiseAncestors(picker);
    positionPanel(picker, panel);
  }

  // Toggle on trigger click
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(SELECTORS.trigger);
    if (trigger) {
      e.preventDefault();
      const picker = trigger.closest(SELECTORS.picker);
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeAllPickers();
      } else {
        openPicker(picker);
      }
      return;
    }

    // Click outside any picker closes them
    if (!e.target.closest(SELECTORS.picker)) {
      closeAllPickers();
    }
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllPickers();
  });

  // Keep an open panel correctly flipped as the page moves
  const reposition = () => {
    document.querySelectorAll(SELECTORS.picker).forEach((p) => {
      const panel = p.querySelector(SELECTORS.panel);
      if (panel && !panel.hidden) positionPanel(p, panel);
    });
  };
  window.addEventListener('resize', reposition, { passive: true });
  window.addEventListener('scroll', reposition, { passive: true });

  // Click a size option = add to cart immediately
  document.addEventListener('click', async (e) => {
    const option = e.target.closest(SELECTORS.option);
    if (!option || option.disabled) return;
    e.preventDefault();

    const variantId = option.getAttribute('data-afc-variant-id');
    const productUrl = option.getAttribute('data-afc-product-url');
    if (!variantId) return;

    const triggerText = option
      .closest(SELECTORS.picker)
      ?.querySelector('.afc-picker__trigger-text');
    const originalTriggerText = triggerText ? triggerText.textContent : '';

    option.classList.add('is-loading');
    if (triggerText) triggerText.textContent = 'Adding…';

    try {
      // Get sections from cart drawer / cart icon bubble for live update if available
      const sectionsToFetch = [];
      const cartDrawer = document.querySelector('cart-drawer');
      const cartIcon = document.querySelector('cart-icon-bubble');
      const cartLiveRegion = document.querySelector('cart-live-region-text');
      if (cartDrawer && cartDrawer.id) sectionsToFetch.push(cartDrawer.id);
      else sectionsToFetch.push('cart-drawer');
      if (cartIcon) sectionsToFetch.push('cart-icon-bubble');
      if (cartLiveRegion) sectionsToFetch.push('cart-live-region-text');

      const body = JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionsToFetch.join(','),
        sections_url: window.location.pathname
      });

      const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Could not add');
      }
      const data = await res.json();

      // Update cart drawer & icon bubble using returned section HTML
      if (data.sections) {
        Object.keys(data.sections).forEach((sectionId) => {
          const html = data.sections[sectionId];
          if (!html) return;
          // Match Spotlight's pattern: re-render the inner of the matching element
          if (sectionId === 'cart-drawer' || (cartDrawer && sectionId === cartDrawer.id)) {
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents({ sections: data.sections, ...data });
            } else if (cartDrawer) {
              const tmp = document.createElement('div');
              tmp.innerHTML = html;
              const newInner = tmp.querySelector('cart-drawer')?.innerHTML;
              if (newInner) cartDrawer.innerHTML = newInner;
            }
          }
          if (sectionId === 'cart-icon-bubble') {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              const tmp = document.createElement('div');
              tmp.innerHTML = html;
              const newBubble = tmp.querySelector('#shopify-section-cart-icon-bubble')?.innerHTML;
              if (newBubble !== undefined) bubble.innerHTML = newBubble;
            }
          }
        });
      }

      // Open the cart drawer
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      option.classList.remove('is-loading');
      option.classList.add('is-success');
      if (triggerText) triggerText.textContent = 'Added ✓';

      setTimeout(() => {
        closeAllPickers();
        option.classList.remove('is-success');
        if (triggerText) triggerText.textContent = originalTriggerText;
      }, 900);
    } catch (err) {
      option.classList.remove('is-loading');
      if (triggerText) triggerText.textContent = originalTriggerText;
      // Fallback: send the user to the product page
      if (productUrl) {
        window.location.href = productUrl;
      } else {
        console.error('AFC quick add failed:', err);
      }
    }
  });
})();
